import { CircularProgress } from '@mui/material';
import React,{useState,useEffect} from 'react'
import DashboardComponent from '../../components/landing/DashboardComponent';
import AppHeader from '../../components/AppHeader';

function PortalRootPage() {

    const [error,setError] = useState(false);
    useEffect(()=>{
        let portalId = localStorage.getItem("portalId");
        if(portalId == null){
            setError(true);
        } else{
            
        }
    },[])

    return (
        
        error ?
            <div className="container">
                <div className="row mt-5">
                    <div className='col-md-12 text-center'>
                        <img src='/images/gtoken-logo.jpg' style={{width:"30%"}} />
                    </div>
                    <div className="col-md-12 text-center">
                        <CircularProgress/>
                    </div>
                    <div className="col-md-12 text-center">
                        <p>Please Scan QR Code </p>
                    </div>
                </div>
            </div>
            :
            <DashboardComponent/>
    )
}

export default PortalRootPage